module.exports = __webpack_public_path__ + "img/5-4.45fe9057.svg";